module.exports = __webpack_public_path__ + "static/media/Group 9001.4763ad91.png";